import {
  INVOICES_REQUEST_FAIL,
  INVOICES_REQUEST_SUCCESS
} from '../action.types'
import initialState from '../initial.state'

export default (state = initialState.invoices, action) => {
  switch (action.type) {
    case INVOICES_REQUEST_SUCCESS:
      return {...action.payload }
    case INVOICES_REQUEST_FAIL:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/invoice/invoices.reducer.js